<template>
  <v-layout row grow>
    <v-flex xs12 sm12 md6 lg5 xl4 pa4>
      <template v-for="(file, index) in documents">
        <v-flex xs12 pa0 :key="'doc_' + index">
          <v-list dense two-line subheader>
            <v-list-tile
              :class="{ fileList: selectedFileIndex == index }"
              avatar
              @click="clicOnListItem(index)"
            >
              <v-list-tile-avatar>
                <v-icon :color="fileIconColor(file.url)">{{
                  fileIcon(file.url)
                }}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="body-1">
                  {{ file.name }}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  <a
                    class="caption"
                    :href="`${s3bucket}/${file.url}`"
                    target="_blank"
                    download
                    >{{ file.url }}</a
                  >
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </template>
    </v-flex>
    <v-divider vertical></v-divider>

    <v-flex
      xs12
      sm12
      md6
      lg7
      xl8
      style="height: inherit;"
      v-if="documents.length > 0"
    >
      <filePreviewer
        :filename="documents[selectedFileIndex].url"
        :url="s3bucket + '/' + documents[selectedFileIndex].url"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import files from "../../mixins/files.js";
import filePreviewer from "../../components/shared/filePreviewer";
export default {
  name: "fileListViewer",
  components: {
    filePreviewer,
  },
  mixins: [files],
  props: {
    title: {
      type: String,
      required: false,
      default: "Available documents",
    },
    documents: {
      type: Array,
      required: true,
    },
    selectedFile: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  methods: {
    clicOnListItem(index) {
      this.selectedFileIndex = index;
    },
  },
  watch: {
    selectedFile() {
      this.selectedFileIndex = this.selectedFile;
    },
  },
  created() {
    this.selectedFileIndex = this.selectedFile;
  },
  data() {
    return {
      selectedFileIndex: this.selectedFile,
    };
  },
};
</script>
<style>
.fileIconBtn {
  height: 64px !important;
  width: 64px !important;
}

.fileList {
  background-color: #eeeeee !important;
}

.uploadList {
  background-color: #f4f4f4 !important;
}

.uploadList .v-list__tile {
  height: min-content !important;
}
</style>
